export const INPUT_STATES = {
  READ: 'read',
  EDIT: 'edit',
  SUBMITTING: 'submitting',
  DEFAULT: 'default'
};

export const getCurrentStates = (state) => {
  return {
    isRead: state === INPUT_STATES.READ,
    isEdit: state === INPUT_STATES.EDIT,
    isSubmitting: state === INPUT_STATES.SUBMITTING,
    isDefault: state === INPUT_STATES.DEFAULT
  };
};
